/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type selectedCurrency_viewer$ref: FragmentReference;
export type selectedCurrency_viewer = {|
  +selected_currency: ?Currency,
  +$refType: selectedCurrency_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "selectedCurrency_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency",
      "args": null,
      "storageKey": null
    }
  ]
};
(node/*: any*/).hash = '2eb1d08aad8d940b7824563e0caa8ecb';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/selectedCurrency_viewer.graphql.js